export const SLOT_COLORS: Record<
  string,
  { bg: string; border: string; text: string; dot: string; badge: "success" | "error" | "accent" }
> = {
  shubh: {
    bg: "bg-green-50/50",
    border: "border-green-100",
    text: "text-green-700",
    dot: "bg-green-500",
    badge: "success",
  },
  ashubh: {
    bg: "bg-red-50/50",
    border: "border-red-100",
    text: "text-red-700",
    dot: "bg-red-500",
    badge: "error",
  },
  neutral: {
    bg: "bg-stone-50/50",
    border: "border-stone-100",
    text: "text-stone-600",
    dot: "bg-stone-400",
    badge: "accent",
  },
};

export function toDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString("en-IN", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

interface CalendarUrlOptions {
  timezone?: string;
  cityName?: string;
}

export function getGoogleCalendarUrl(
  date: string,
  start: string,
  end: string,
  reason: string,
  options: CalendarUrlOptions = {}
): string {
  const { timezone = "Asia/Kolkata", cityName = "New Delhi" } = options;

  const parseTime = (timeStr: string) => {
    const [time, modifier] = timeStr.split(" ");
    const parts = time.split(":").map(Number);
    let hours = parts[0];
    const minutes = parts[1];
    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;
    return { hours, minutes };
  };

  const fmt = (t: { hours: number; minutes: number }) =>
    `${date.replace(/-/g, "")}T${String(t.hours).padStart(2, "0")}${String(t.minutes).padStart(2, "0")}00`;

  const title = encodeURIComponent(`Shubh Muhurat (${reason || "Auspicious Timing"})`);
  const dates = `${fmt(parseTime(start))}/${fmt(parseTime(end))}`;
  const details = encodeURIComponent(
    `Auspicious timing calculated by Ishvaram Jyotish for ${cityName}.\n\nReason: ${reason}\nGenerated via https://ishvaram.com`
  );

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${dates}&ctz=${encodeURIComponent(timezone)}&details=${details}`;
}
